var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.klass,attrs:{"small":"","color":_vm.color,"outlined":_vm.outlined}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.status)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }